import React, { } from 'react';
import { FloatingCallActionHoc, FloatingCallVideoHoc, FloatingCallAudioHoc } from '../../../assets/images';
import './FloatingCallOption.scss';

const FloatingCallOption = (props={}) => {
   const {handleAudioCall, handleVideoCall} = props;
    return (
        <label className="FloatingCallAction" htmlFor="FloatingAction">
            <input id="FloatingAction" type="checkbox"/>
            <span>
            <FloatingCallActionHoc viewBox="0 0 25 25"/>
            </span>
            <ul>
                <li title="Video call" onClick={handleVideoCall ? handleVideoCall : null} >
                    <i>
                       <FloatingCallVideoHoc viewBox="0 0 20.013 12.205"/>
                    </i>
                </li>
                <li title="Audio call" onClick={handleAudioCall ? handleAudioCall : null}>
                    <i>
                    <FloatingCallAudioHoc viewBox="0 0 20 20"/>
                    </i>
                </li>
            </ul>
        </label>
    );
}

export default FloatingCallOption;
